export default __webpack_public_path__ + "static/media/photo--sm--2.8e75373c.jpg";